module.exports = __webpack_public_path__ + "img/exception.3d4ccbac.jpeg";